import { render, staticRenderFns } from "./colelDetails.vue?vue&type=template&id=4db236f8&scoped=true&"
import script from "./colelDetails.vue?vue&type=script&lang=js&"
export * from "./colelDetails.vue?vue&type=script&lang=js&"
import style0 from "./colelDetails.vue?vue&type=style&index=0&id=4db236f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db236f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
